define('gameday-index-gdads/GDIndexAdsComponent',['require','exports','module','jquery','gameday-index-component-base/GDIndexComponentBase','gameday-index-configurator/GamedayIndexConfigurator','message-service/message-service','gameday-index-enums/enums/events/LoadEvents','gameday-index-enums/enums/events/SponsorshipEvents','message-service/message-service','./subcomponents/AdvertisingUtils','app-console/app-console','./subcomponents/GDIndexAdUnit','doubleclick/gpt','doubleclick/interstitial'],function(require, exports, module) {
	// require imports
	var $ = require("jquery"),
		BaseClass = require("gameday-index-component-base/GDIndexComponentBase"),
		Configs = require("gameday-index-configurator/GamedayIndexConfigurator"),
		dispatcher = require("message-service/message-service"),
		LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
		AdEvents = require("gameday-index-enums/enums/events/SponsorshipEvents"),
		MessageService = require("message-service/message-service"),
		AdUtils = require( "./subcomponents/AdvertisingUtils" ),
		logg = require("app-console/app-console"),
		AdUnit = require( "./subcomponents/GDIndexAdUnit" ),
		Doubleclick = require('doubleclick/gpt'),
		// Need this in the build for runtime
		interstitial = require( "doubleclick/interstitial" );

	// instance variables
	var Superclass,
		pageUnits = {},
		adConfig = {},
		refreshRate = 60000,
		refreshInterval,
		banners = ["ad-top-banner-xs-s", "ad-top-banner-m", "ad-top-banner-l-xl"],
		refreshAds = [],// ["ad-skin", "ad-header-sponsor", "ad-live-chyron-left", "ad-live-chyron-right"],
		tertiaryHierarchy,
		branding = [];

	function GDAds(compID, divID) {
		this.componentID = compID;
		this.targetDiv = divID;
		this.init();
	}

	BaseClass.spawn(GDAds).define({
		init: function() {
			var self = this;
			this.buildAppSettings();

			// MessageService.one('init_data_loaded', init_stageTwo);
			MessageService.one('init_data_loaded', function(){
				self.drawAds();
				self.startRefreshTimer();
				// After the first load, do some stuff on refresh
				MessageService.on('init_data_loaded',function(){
					AdUtils.getKeyVals(adConfig);
				})
				MessageService.on('gameStateChanged',function(){
					AdUtils.getKeyVals(adConfig);
				})
			});
			// function init_stageTwo() {
			// 	// self.startRefreshTimer();
			// 	self.initialized = true;
			// }

			dispatcher.publish(LoadEvts.componentReady, this.componentID);
		},

		buildAppSettings: function() {
			var units,
				key,
				refresh;

			adConfig = Configs.siteConfig.getAds();
			refresh = adConfig.refresh;
			pageUnits = [];
			if(refresh === true){
				refresh = 60;
			}else if (refresh === false){
				refresh = 0;
			}
			refreshRate = ~~refresh * 1000;

			units = adConfig.units;

			for (key in units){
				pageUnits.push(units[key]);
			}
			// TODO Determine tertiary hierarchy
			// tertiaryHierarchy =
		},

		drawAds: function() {
			var i;

			refreshAds = pageUnits.map(function(unit){
				return	unit.container;
			});

			// filter out the 1x1 from the refresh group
			refreshAds = refreshAds.filter(function(cont) {
				return (cont.toString().indexOf("interstitial" < 0));
			});

			var init = {
				skinElement: adConfig.skinElement, // element for takeover
				inventoryHierarchy : adConfig.inventoryHierarchy,
				outOfPageAd : adConfig.outOfPageAd,
				thresholds : adConfig.thresholds,
				responsive : !!adConfig.responsive
			};

			Doubleclick.init(init);

			AdUtils.getKeyVals(adConfig);

			for(i=0; i < pageUnits.length; i++){

				if(pageUnits[i].customBranding){
					this.setWindowAccess();
					this.createCustomBranding(pageUnits[i].customBranding);
				}

				Doubleclick.defineSlot(pageUnits[i]);
				if(document.getElementById(pageUnits[i].container)){
					Doubleclick.display(pageUnits[i].container)
				}
				
			}
			dispatcher.on.call(this,'gd-refresh-ads',this.refreshAds);
			dispatcher.on.call(this,'gd-display-ads',this.displayAds);

		},
		createCustomBranding : function(units){
			var key;
			units = units || {};
			for(key in units){
				branding.push(new AdUnit(units[key]));
			}
		},
		startRefreshTimer: function() {
			if(refreshRate > 0){
				refreshInterval = setInterval(this.refreshAds, refreshRate);
			}
		},

		stopRefreshTimer: function() {
			refreshInterval = false;
		},
		displayAds: function(ads){
			var reUp = [].concat(ads || refreshAds);
			reUp.forEach(Doubleclick.display);
		},
		refreshAds: function(ads) {
			var reUp = [].concat(ads || refreshAds);
			Doubleclick.refresh(reUp);
		},
		setWindowAccess: function() {
			window.setRails = function(adObj) {
				var adProps = {
						bgColor: adObj.bgColor || '#000000',
						bgPosition: adObj.bgPosition || '',
						bgRepeat: adObj.bgRepeat || 'no-repeat',
						bgAttachment: adObj.bgAttachment || 'scroll',
						clickHref: adObj.clickHref || null,
						clickTarget: adObj.clickTarget || '_blank',
						clickHeight: adObj.clickHeight || '900px',
						clickTop: adObj.clickTop || '0'
				};

				var leftRail = $.extend({}, adProps, {
						img: (adObj.leftImage) ? 'url(' + adObj.leftImage + ')' : 'none',
						targetID: (adObj.leftRail) ? $(adObj.leftRail) : 'leftRailAdTag'
					}),
					rightRail = $.extend({}, adProps, {
						img: (adObj.rightImage) ? 'url(' + adObj.rightImage + ')' : 'none',
						targetID: (adObj.rightRail) ? $(adObj.leftRail) : 'rightRailAdTag'
					});

				dispatcher.publish(AdEvents.refreshAdImage, leftRail);
				dispatcher.publish(AdEvents.refreshAdImage, rightRail);
			};
			window.GDApp = window.GDApp || {};
			window.GDApp.displayBranding = function(adObj) {
				var adProps = {
						bgColor: adObj.bgColor || '#000000',
						bgPosition: '',
						bgRepeat: adObj.bgRepeat || 'no-repeat',
						bgAttachment: adObj.bgAttachment || 'scroll',
						clickHref: adObj.clickHref || null,
						clickTarget: adObj.clickTarget || '_blank',
						clickHeight: adObj.clickHeight || '100%',
						clickTop: adObj.clickTop || '0'
				};

				var branding = adObj.scoreboard && $.extend({}, adProps, {
						img: 'url(' + adObj.scoreboard.image + ')',
						clickHref: adObj.scoreboard.clickthru,
						target: '_blank'
					}),
					sponsor = adObj.header && $.extend({}, adProps, {
						img: 'url(' + adObj.header.image + ')',
						clickHref: adObj.header.clickthru,
						targetID: 'sponsorAdTag'
					});

				if (sponsor) {
					dispatcher.publish(AdEvents.refreshAdImage, sponsor);
				}

				if (branding) {
					dispatcher.publish(AdEvents.updateChyronAds, branding);
				}
			};
		}
	});

	Superclass = GDAds.superclass;
	return GDAds;
});
